import { render, staticRenderFns } from "./SendSMSDialog.vue?vue&type=template&id=27dd6590&scoped=true"
import script from "./SendSMSDialog.vue?vue&type=script&lang=ts"
export * from "./SendSMSDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dd6590",
  null
  
)

export default component.exports